import React, { useEffect, useRef } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
import { useAppDispatch } from '@/store/hooks';
import { setMapBounds, setZoom } from '@/store/slices/mapUiSlice';

const MapHandler: React.FC = () => {
  const map = useMap();
  const dispatch = useAppDispatch();

  const initialBoundsSet = useRef(false);

  useEffect(() => {
    if (!map) return;

    const handleMapChange = () => {
      try {
        const bounds = map.getBounds();
        const zoom = map.getZoom();
        if (!bounds || typeof zoom !== 'number' || isNaN(zoom)) {
          return;
        }

        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();
        dispatch(setZoom(zoom));

        const boundsLiteral: google.maps.LatLngBoundsLiteral = {
          north: ne.lat(), east: ne.lng(),
          south: sw.lat(), west: sw.lng()
        };
        dispatch(setMapBounds(boundsLiteral));

      } catch (error) {
        console.error("[MapHandler] Error updating map state:", error);
      }
    };

    if (!initialBoundsSet.current) {
        handleMapChange();
        initialBoundsSet.current = true;
    }

    const idleListener = map.addListener('idle', handleMapChange);

    return () => {
      google.maps.event.removeListener(idleListener);
    };
  }, [map, dispatch]);

  return null;
};

export default MapHandler; 